module.exports = __webpack_public_path__ + "static/media/soc-icon.ac02d819.png";